import React from 'react';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';

export default function FinalCTA() {
  const bookSession = () => {
    window.open('https://topmate.io/mugdha_clarity90/2028348', '_blank');
  };

  return (
    <section className="py-24 bg-brand-deep text-brand-cream text-center border-b border-brand-cream/10">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="font-serif text-3xl md:text-4xl leading-relaxed mb-12">
            Everything in Clarity90 is designed to work without you at the centre of it.
            <br /><br />
            Not because you are the problem.
            <br />
            <span className="text-brand-sand">Because you are too important to be the solution to every problem.</span>
          </p>
          <Button onClick={bookSession}>
            Book a Clarity Session
          </Button>
        </Reveal>
      </div>
    </section>
  );
}